import React from 'react';
import { connect } from 'react-redux';

import Parser from '../components/Parser';
import InputFile from '../components/InputFile';
import { changeExportFile, getExportContent, startOver, parseXMLNodes } from '../actions';

const mapStateToProps = (state) => (
	{
    exportFileContent: state.parseExportFile.exportFileContent,
    exportFile: state.parseExportFile.exportFile,
    isExportFileSelected : state.parseExportFile.isExportFileSelected,
    hasBeenRead: state.parseExportFile.hasBeenRead
	}
)

const mapDispatchToProps = (dispatch) => (
	{
	  uploadFile: (event) => dispatch(changeExportFile(event.target.files[0])),
	  parseFileContent: (file) => {

	  	if (file) {

		    const fileReader = new FileReader();
		    fileReader.onloadend = () => {

		      dispatch(getExportContent(fileReader.result))
		      dispatch(parseXMLNodes(fileReader.result))
		    }

		    fileReader.readAsText(file)
	  	}
	  },
	  startOver: () => dispatch(startOver())
	}
)

class FileInput extends React.Component {

	render() {

		const { uploadFile, exportFile, isExportFileSelected, parseFileContent, startOver, hasBeenRead } = this.props;

		let inputFieldClass = 'dib mv2 ';
		inputFieldClass += isExportFileSelected ? 'bg-brand-green' : 'bg-light-red';

		return (

			<div className='pa2 black ma1 bg-brand-green'>
				<div>Do an 'All Content' import of your site and upload the XML here.</div>
				<div className={inputFieldClass}>
				{
					!isExportFileSelected ?
						<div className='dib'><InputFile onUploadFile={uploadFile} /></div>
						:
						<div>
							<div className='bg-white pa2 mv2 dib f6'>
								<span>{exportFile.name}</span>
								<input type='button' className='pointer f7 f5-ns bn ba1 b--solid b--black pa2 ml2' value="Change" onClick={startOver} />
							</div>

							{ !hasBeenRead ? <Parser onParse={parseFileContent} file={exportFile} /> : '' }

						</div>
				}
				</div>
				<div className='black f7 mt2'>
					NOTE: Your data is safe. All operations only happen on your computer; no data will be saved/processed outside.
				</div>
			</div>
			)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(FileInput);